export function checkRolesAccessibilities(
	rolesAccessibilities,
	role,
	module,
	feature,
	accessibilityId
) {
	if (
		rolesAccessibilities[role] &&
		rolesAccessibilities[role][module] &&
		rolesAccessibilities[role][module][feature]
	) {
		let accessibilities = rolesAccessibilities[role][module][feature];
		return accessibilities.includes(accessibilityId);
	}
	return false;
}
